import React from "react";
import { useTranslation } from "react-i18next";
import perfil from "../images/perfil_portifolio.png";

export function Sobre() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col justify-center bg-gray-800 px-2 py-12 sm:px-3 lg:px-5 lg:py-16">
      <div className="mx-auto flex w-full max-w-screen-2xl flex-col items-stretch gap-12 lg:flex-row lg:items-start lg:gap-8 xl:gap-10">
        <div className="flex min-w-0 flex-1 basis-0 items-center justify-center">
          <img
            className="mx-auto h-auto w-auto max-h-[min(70vh,600px)] max-w-full object-contain sm:max-h-[min(74vh,648px)] lg:max-h-[min(82vh,696px)] rounded-2xl shadow-md shadow-black/15"
            src={perfil}
            alt="Laert Furquin"
          />
        </div>
        <div className="min-w-0 flex-1 basis-0 space-y-8 text-center text-lg leading-loose text-gray-300 sm:space-y-9 lg:space-y-10 lg:text-left">
          <p>{t("sobre.p1")}</p>
          <p>{t("sobre.p2")}</p>
          <p>{t("sobre.p3")}</p>
          <p>{t("sobre.p4")}</p>
        </div>
      </div>
    </div>
  );
}

export default Sobre;
